import { render } from "./Scripts.vue?vue&type=template&id=5c4ac906"
import script from "./Scripts.vue?vue&type=script&lang=js"
export * from "./Scripts.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src755111659/src/application/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__